import React from 'react'

function ToolCheckIcon({ className }) {
  return (
    <svg
      className={className}
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="22" cy="22" r="22" fill="white" />
      <g clipPath="url(#clip0_13571_124580)">
        <path
          d="M22 42C33.0469 42 42 33.0469 42 22C42 10.9531 33.0469 2 22 2C10.9531 2 2 10.9531 2 22C2 33.0469 10.9531 42 22 42ZM30.8281 18.3281L20.8281 28.3281C20.0938 29.0625 18.9063 29.0625 18.1797 28.3281L13.1797 23.3281C12.4453 22.5938 12.4453 21.4063 13.1797 20.6797C13.9141 19.9531 15.1016 19.9453 15.8281 20.6797L19.5 24.3516L28.1719 15.6719C28.9062 14.9375 30.0937 14.9375 30.8203 15.6719C31.5469 16.4062 31.5547 17.5937 30.8203 18.3203L30.8281 18.3281Z"
          fill="#5BBAB9"
        />
      </g>
      <defs>
        <clipPath id="clip0_13571_124580">
          <rect width="40" height="40" fill="white" transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  )
}
ToolCheckIcon.defaultProps = {
  className: '',
}

export default ToolCheckIcon
